import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

import { ERROR_MESSAGES } from "constants/validation";

/**
 * Transaction Product Schema
 * Represents product transactions in the system
 * Base schema is loose to allow loading legacy data.
 */
export const TransactionProductSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    affiliateId: Yup.number().nullable(),
    productId: Yup.number().nullable(),
    productTransactionId: Yup.number().nullable(),
    productAmount: Yup.number().nullable(),
    commissionAmount: Yup.number().nullable(),
    bonusAmount: Yup.number().nullable(), // Loose for loading
    datetime: Yup.date().nullable(),
  });

/**
 * Transaction Product Validation Schema
 * Strict rules applied only during form submission.
 */
export const TransactionProductValidationSchema = TransactionProductSchema.clone().shape({
  bonusAmount: Yup.number()
    .required(ERROR_MESSAGES.BONUS_AMOUNT_REQUIRED)
    .min(0, ERROR_MESSAGES.AMOUNT_MIN(0)),
});
